module.exports = __webpack_public_path__ + "static/media/5ka.3062f8b3.svg";